export default __webpack_public_path__ + "static/FM3-logo-d8d1eed81929f31cde3e9c5a98b81fbd.png";